<div class="registry-geo" [style.height]="altura() === '100%' ? '100%' : null">
  @if (falhouCarregar()) {
    <div class="registry-geo__empty" [style.height]="altura()">
      Não foi possível exibir o mapa. Recarregue a página para tentar de novo.
    </div>
  } @else if (!pontos().length) {
    <div class="registry-geo__empty" [style.height]="altura()">
      Sem empresas com localização para plotar.
    </div>
  } @else {
    <div
      #mapa
      class="registry-geo__map"
      [style.height]="altura()"
      role="application"
      aria-label="Mapa geográfico das empresas"></div>
  }

  <div class="registry-geo__cost">
    <span class="registry-geo__cost-title">Custo do mapa</span>
    @for (p of custo().partes; track p) {
      <span>· {{ p }}</span>
    }
    <span class="registry-geo__cost-total">{{ custo().estimativa }}</span>
  </div>
</div>
